module.exports = __webpack_public_path__ + "assets/img/mapBj.7b4cc003.png";